import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../configure_store'

const _getState = (state: RootState) => state.terms

export const getTerms = createSelector(_getState, state => state.terms)
